/**
 * Supplier Interview zod schemas — 前後端共用。
 * 與 interview.schema.ts(客戶訪談)平行,結構相同,只把 owner FK 改成 supplierId。
 *
 * 共用的 schema(body 與 attachment metadata)直接從 interview.schema.ts re-export:
 *  - CreateInterviewSchema / UpdateInterviewSchema:訪談 body(無 owner FK)
 *  - PresignUploadSchema / CreateAttachmentSchema:附件上傳兩段式
 *  - InterviewAttachmentSchema:附件 metadata 回傳格式
 *  - InterviewListQuerySchema:列表 query string
 *  - InterviewTypeBriefSchema / InterviewCreatorBriefSchema:nested 顯示用
 *
 * 只有「回傳 row」會有 supplier 專屬 schema(SupplierInterviewResponseSchema),
 * 因為它含 supplierId 而非 customerId。
 */
import { z } from 'zod';
import {
  InterviewAttachmentSchema,
  InterviewCreatorBriefSchema,
  InterviewTypeBriefSchema,
} from './interview.schema';

/** GET /suppliers/:sid/interviews / GET /supplier-interviews/:id 回傳 row。 */
export const SupplierInterviewResponseSchema = z.object({
  id: z.number().int().positive(),
  supplierId: z.number().int().positive(),
  interviewTypeId: z.number().int().nullable(),
  interviewType: InterviewTypeBriefSchema.nullable(),
  contact: z.string().nullable(),
  notes: z.string().nullable(),
  visitedAt: z.string().datetime().nullable(),
  notifyDaily: z.boolean().default(false),
  createdById: z.number().int().positive(),
  createdBy: InterviewCreatorBriefSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable(),
  attachments: z.array(InterviewAttachmentSchema).default([]),
});

export type SupplierInterviewResponse = z.infer<typeof SupplierInterviewResponseSchema>;
